import { DatePicker } from 'antd';
import Box from 'components/Box';
import Button from 'components/Button';
import dayjs from 'dayjs';
import { useState } from 'react';
import styled from 'styled-components';
type Props = {
  onViewYearlyPreview: (year: number) => void;
};
const ButtonYearlyPayrollReport = ({ onViewYearlyPreview }: Props) => {
  const [open, setOpen] = useState(false);
  const onSelect = async (a: dayjs.Dayjs) => {
    onViewYearlyPreview(a.year());
  };

  return (
    <Container display='flex' alignItems='center'>
      <DatePicker
        picker='year'
        clearIcon={false}
        inputReadOnly
        onSelect={onSelect}
        suffixIcon={false}
        open={open}
        onOpenChange={setOpen}
        popupClassName={'zoom-big-v3'}
        className='ant-picker-custom-year'
        inputRender={() => {
          return (
            <Button width='10rem' cardCashier ntype='DARK_BLUE' className='btn-print' icon="printWhite" onClick={() => setOpen(true)}>
              1099 Report
            </Button>
          );
        }}
      />
    </Container>
  );
};

export default ButtonYearlyPayrollReport;
const Container = styled(Box)`
  .ant-picker.ant-picker-custom-year {
    padding: 0 !important;
    box-shadow: none !important;
    border: none !important;
    background: none !important;
    .ant-picker-input {
      padding: 0 !important;
      border: none !important;
      background: none !important;
    }
    .ant-picker-input input {
      padding: 0 !important;
      border: none !important;
      background: none !important;
    }
  }
`;